import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput"

class ConfiguracionCuentas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cuentaCobrosCuotas_id: null,
      cuentasComisionesPorVentas_id: null,
      cuentasGastosAdministrativos_id: null,
      cuentasGastosJudiciales_id: null,
      cuentasFijas: [],

      postVariables: ['cuentaCobrosCuotas_id', 'cuentasFijas', 'cuentasComisionesPorVentas_id', 'cuentasGastosAdministrativos_id','cuentasGastosJudiciales_id'],
      errors: [],
    };
  }

  static propTypes = {
    nav: PropTypes.any,
  }

  getData() {
    const { postVariables } = this.state;
    let data = {};
    postVariables.forEach(x => {
      data[x] = this.state[x];
    });

    return data;
  }

  resetForm() {
    this.setState({
      cuentaCobrosCuotas_id: null,
      cuentasFijas: [],
    });
  }

  setData(data) {

    this.setState({
      cuentaCobrosCuotas_id: data.cuentaCobrosCuotas ? data.cuentaCobrosCuotas.id : null,
      cuentasComisionesPorVentas_id: data.cuentasComisionesPorVentas ? data.cuentasComisionesPorVentas.id : null,
      cuentasGastosAdministrativos_id: data.cuentasGastosAdministrativos ? data.cuentasGastosAdministrativos.id : null,
      cuentasGastosJudiciales_id: data.cuentasGastosJudiciales ? data.cuentasGastosJudiciales.id : null,
      cuentasFijas: data.cuentasFijas ? data.cuentasFijas : [],
    });
  }

  setErrors(errors) {
    this.setState({
      errors: errors,
    });
  }

  onChangeField(field, value) {
    this.setState(prevState => {
      let errors = prevState.errors;
      if (errors) errors[field] = null;
      prevState.errors = errors;
      prevState[field] = value;
      return prevState;
    });
  }

  getError(field) {
    let errors = this.state.errors;
    if (errors) return errors[field];
    else return null;
  }

  toggleCheckActive = (field, value) => {
    this.onChangeField(field, !value);
  }


  render() {
    const { cuentaCobrosCuotas_id, cuentasFijas, cuentasComisionesPorVentas_id, cuentasGastosAdministrativos_id, cuentasGastosJudiciales_id } = this.state;

    return (
      <ParadigmaModal
        navButton={true}
        nav={this.props.nav}
        getUrl={api.caja.configuracionCuentas}
        submitUrl={api.caja.configuracionCuentas}
        submitType={"PUT"}

        id={null}

        onGotData={(data) => this.setData(data)}
        onGotErrors={(errors) => this.setErrors(errors)}
        onSubmit={(e) => null}
        onClose={() => this.resetForm()}
        onPreSubmit={() => this.getData()}

        title={"Configuración Cuentas"}
        className="ui-paradigma-modal ui-paradigma-modal-wide"

        successMessage={"La Configuración ha sido editada con éxito."}
        missingIdMessage={"Debe seleccionar una fila."}
        buttonTitle={"Editar"}
        buttonIcon={"fa fa-pencil fa-lg"}
        saveButton={true}
        closeButton={true}
      >

        <section className="ui-modal-section">
          <p className="ui-section-label">Cuentas por defecto</p>
          <div className="ui-form-grid">
            <ParadigmaLabeledInput
              md={[12, 12]}
              classNames={["ui-field-label-col", "ui-field-control-col"]}
              label="Cuenta de Cobros"
              inputComponent={
                <ParadigmaAsyncSeeker
                  url={api.caja.cuentas}
                  value={cuentaCobrosCuotas_id}
                  parameters={{
                    paginationEnabled: false,
                    sort: ['nombre']
                  }}
                  onChange={e => this.onChangeField('cuentaCobrosCuotas_id', (e) ? (e.id) : (null))}
                />
              }
              error={() => this.getError('cuentaCobrosCuotas_id')}
            />

            <ParadigmaLabeledInput
              md={[12, 12]}
              classNames={["ui-field-label-col", "ui-field-control-col"]}
              label="Cuentas Fijas"
              error={() => this.getError('cuentasFijas')}
              inputComponent={
                <ParadigmaAsyncSeeker
                  multiselect={true}
                  url={api.caja.cuentas}
                  value={cuentasFijas}
                  onChange={data => this.onChangeField('cuentasFijas', data ? data.map(e => e.id) : [])}
                  parameters={{
                    paginationEnabled: false,
                    sort: ['nombre'],
                  }}
                />
              }
            />
          </div>
        </section>

        <section className="ui-modal-section">
          <p className="ui-section-label">Cuentas operativas</p>
          <div className="ui-form-grid">
            <ParadigmaLabeledInput
              md={[12, 12]}
              classNames={["ui-field-label-col", "ui-field-control-col"]}
              label="Cuenta de Comisiones Por Ventas"
              inputComponent={
                <ParadigmaAsyncSeeker
                  url={api.caja.cuentas}
                  value={cuentasComisionesPorVentas_id}
                  parameters={{
                    paginationEnabled: false,
                    sort: ['nombre']
                  }}
                  onChange={e => this.onChangeField('cuentasComisionesPorVentas_id', (e) ? (e.id) : (null))}
                />
              }
              error={() => this.getError('cuentasComisionesPorVentas_id')}
            />

            <ParadigmaLabeledInput
              md={[12, 12]}
              classNames={["ui-field-label-col", "ui-field-control-col"]}
              label="Cuenta de Gastos Administrativos"
              inputComponent={
                <ParadigmaAsyncSeeker
                  url={api.caja.cuentas}
                  value={cuentasGastosAdministrativos_id}
                  parameters={{
                    paginationEnabled: false,
                    sort: ['nombre']
                  }}
                  onChange={e => this.onChangeField('cuentasGastosAdministrativos_id', (e) ? (e.id) : (null))}
                />
              }
              error={() => this.getError('cuentasGastosAdministrativos_id')}
            />

            <div className="ui-span-2">
              <ParadigmaLabeledInput
                md={[12, 12]}
                classNames={["ui-field-label-col", "ui-field-control-col"]}
                label="Cuenta de Gastos Judiciales"
                inputComponent={
                  <ParadigmaAsyncSeeker
                    url={api.caja.cuentas}
                    value={cuentasGastosJudiciales_id}
                    parameters={{
                      paginationEnabled: false,
                      sort: ['nombre']
                    }}
                    onChange={e => this.onChangeField('cuentasGastosJudiciales_id', (e) ? (e.id) : (null))}
                  />
                }
                error={() => this.getError('cuentasGastosJudiciales_id')}
              />
            </div>
          </div>
        </section>


      </ParadigmaModal>
    );
  }
}

export default ConfiguracionCuentas;



// WEBPACK FOOTER //
// ./src/views/Caja/ConfiguracionCuentas/ConfiguracionCuentas.js